<script>
export default {
  name: "DevicesByTargetFirmware",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    revision: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      chartData: [],
      chartOptions: [],
    }
  },
  methods: {
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      return {
        labels: this.data.map((i) => i.target_firmware ? `Version ${i.target_firmware.version_number}` : 'Default'),
        datasets: [
          {
            label: 'Devices',
            data: this.data.map((i) => i.total),
            hoverOffset: 4,
          },
        ]
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      return {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          }
        }
      };
    }
  },
  watch: {
    'data': {
      handler(newValue, oldValue) {
        this.chartData = this.setChartData();
        this.chartOptions = this.setChartOptions();
      },
      immediate: true,
    },
  },
}
</script>

<template>
  <Card>
    <template #title>Devices by Target Firmware</template>
    <template v-if="revision" #subtitle>For Revision {{ revision.name }}</template>
    <template #content>
      <Chart type="pie" :data="chartData" :options="chartOptions"/>
    </template>
  </Card>
</template>

<style scoped>

</style>
